<template>
    <svg width="27" height="27" viewBox="0 0 27 27" xmlns="http://www.w3.org/2000/svg">
        <path d="m26.353 24.082-7.9-7.78a10.226 10.226 0 1 0-8.215 4.15 10.153 10.153 0 0 0 6.097-2.024l7.925 7.804a1.491 1.491 0 0 0 2.116-.022 1.51 1.51 0 0 0-.023-2.128zM2.993 10.157a7.246 7.246 0 1 1 7.245 7.291 7.275 7.275 0 0 1-7.245-7.291z" fill="#033D89" fill-rule="nonzero"/>
    </svg>
</template>

<script>
export default {
    name: 'IconSearch',
};
</script>
